import { AxiosPromise } from 'axios'

import api from '@config/api'

export interface IControleFornecedorFiltro {
  empresasIds?: number[]
  lojasIds?: number[]
  fornecedoresIds?: number[]
  categoriasCompactasIds?: number[]
  compradores?: string[]
  emAtraso?: boolean | null
  pendencia?: boolean | null
  dataAtualizacaoInicio?: string
  dataAtualizacaoFim?: string
}

export interface IControleFornecedorItem {
  compradorEmail: string
  empresaId: number
  empresaNome: string
  lojaId: number
  lojaNome: string
  fornecedorId: number
  fornecedorNome: string
  categoriaCompactaId: number
  categoriaCompactaNome: string
  frequencia: number
  proximaCompraPrevista: string
  emAtraso: boolean
  pendencia: boolean
  dataAtualizacao: string
}

export interface IControleFornecedorResponse {
  success: boolean
  message: string
  data: IControleFornecedorItem[]
}

export interface IPagination {
  actualPage: number
  rows: number
}

export function getControleFornecedor(
  filtro: IControleFornecedorFiltro,
  pagination: IPagination
): AxiosPromise<IControleFornecedorResponse> {
  const queryParams = new URLSearchParams()
  queryParams.append('pagination', JSON.stringify(pagination))

  return api.post<IControleFornecedorResponse>(
    `v1/ControleFornecedor?${queryParams.toString()}`,
    filtro
  )
}

// Histórico de alterações do cronograma de todos os compradores da empresa
// (usuarioEmail = autor; o comprador alterado vem no texto de acao)
export function getControleFornecedorHistorico(
  empresaId: number
): AxiosPromise<any> {
  return api.get(`v1/ControleFornecedor/Historico/${empresaId}`)
}

// CONTROLE FORNECEDOR ESCOPO DIA
export interface IControleFornecedorEscopoDiaFiltro {
  dataInicio: string
  dataFim: string
  empresasIds?: number[]
  lojasIds?: number[]
  fornecedoresIds?: number[]
  categoriasCompactasIds?: number[]
  tipos?: number[]
  compradores?: string[]
}

export interface IControleFornecedorEscopoDiaItem {
  id: number
  data: string
  empresaId: number
  empresaNome: string
  lojaId: number
  lojaNome: string
  fornecedorId: number
  fornecedorNome: string
  categoriaCompactaId: number
  categoriaCompactaNome: string
  frequencia: number
  tipo: number
  tipoDescricao: string
  compradores?: string
  compradoresEmails?: string
  quantidadeCompradores: number
  ultimaCompraDiaCerto?: string
  ultimaCompraRealizada?: string
  proximaCompraPrevista?: string
  emAtraso?: boolean
  pendencia?: boolean
  dataAtualizacao?: string
}

export interface IEscopoDiaPagination {
  actualPage: number
  rows: number
  totalRows: number
  totalPages: number
  skip: number
  paginate: boolean
}

export interface IControleFornecedorEscopoDiaResponse {
  success: boolean
  message: string
  data: IControleFornecedorEscopoDiaItem[]
  pagination: IEscopoDiaPagination
}

export function getControleFornecedorEscopoDia(
  filtro: IControleFornecedorEscopoDiaFiltro,
  pagination: IPagination
): AxiosPromise<IControleFornecedorEscopoDiaResponse> {
  const queryParams = new URLSearchParams()
  queryParams.append('pagination', JSON.stringify(pagination))

  return api.post<IControleFornecedorEscopoDiaResponse>(
    `v1/ControleFornecedorEscopo?${queryParams.toString()}`,
    filtro
  )
}

// RECOMENDACAO COMPRAS (Histórico de Recomendações)
export interface IRecomendacaoComprasFiltro {
  dataInicio: string
  dataFim: string
  empresasIds?: number[]
  lojasIds?: number[]
  fornecedoresIds?: number[]
  categoriasCompactasIds?: number[]
  mundosIds?: number[]
  produtosIds?: number[]
  compradoresIds?: number[]
  curvasABCD?: string[]
  tiposAlerta?: number[]
  somenteAlterados?: boolean | null
}

export function getRecomendacaoCompras(
  filtro: IRecomendacaoComprasFiltro,
  pagination: IPagination
): AxiosPromise {
  const queryParams = new URLSearchParams()
  queryParams.append('pagination', JSON.stringify(pagination))

  return api.post(`v1/RecomendacaoCompras?${queryParams.toString()}`, filtro)
}
